import * as Sentry from '@sentry/browser'

import { version } from '../../package.json'

export const setupSentry = (token = '', environment = '') => {
  if (!token) {
    throw new Error('Token is required')
  }

  Sentry.init({
    dsn: token,
    environment,
    release: version
  })
}

export const identifyUser = (token = '', email = '') => {
  if (!token) {
    throw new Error('Token is required')
  }

  try {
    Sentry.configureScope((scope) => {
      scope.setUser({ username: email })
    })
  } catch (e) {
    console.error('Sentry identify error: ', e)
  }
}

export const logException = (err, msg) => {
  try {
    Sentry.captureMessage(msg)
    err && Sentry.captureException(err)
  } catch (e) {
    console.error('Sentry error: ', e)
    console.log(msg)
    console.log(err)
  }
}

export const setupIndexedDBErrorHandler = () => {
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason &&
      event.reason.name === 'UnknownError' &&
      String(event.reason.message).includes('Indexed Database')
    ) {
      logException(
        new Error('IndexedDB connection lost. This is a browser-level error.'),
        'IndexedDB_UnknownError'
      );
      // Optionally, show a user-friendly message to the user here
      alert('Browser error: Connection to storage lost. Please refresh the page.');
    }
  });
};
